import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";

export const TemplateHeader = () => {
    const feedback = useContext(RecordContext);

    if (!feedback) return null;

    return (
        <DetailHeader collection={feedback.collection}>
            <Grid>
                <Typography variant="h6" color="secondary">
                    Template
                </Typography>
            </Grid>
        </DetailHeader>
    );
};
